import lodash from 'lodash';

export default {
	install(app) {
		app.prototype.$_ = lodash;
	},
};
